/**
 * Configuração vinda do ambiente. Só valor **publicável** entra aqui: a chave anônima é
 * desenhada para viajar no navegador — quem barra o acesso é a RLS, não o segredo dela.
 * A `service_role` NUNCA pode aparecer neste diretório.
 */
import type { ConfigSupabase } from '../../../packages/dados/src/cliente';

interface Ambiente {
  readonly VITE_SUPABASE_URL?: string;
  readonly VITE_SUPABASE_ANON_KEY?: string;
  /** `demonstracao` quando o banco por trás é o de desenvolvimento. */
  readonly VITE_AMBIENTE?: string;
  readonly DEV?: boolean;
}

const amb = import.meta.env as unknown as Ambiente;

export class ConfigAusente extends Error {}

export function configSupabase(): ConfigSupabase {
  const url = amb.VITE_SUPABASE_URL ?? '';
  const chave = amb.VITE_SUPABASE_ANON_KEY ?? '';
  if (url === '' || chave === '') {
    throw new ConfigAusente(
      'Falta o endereço do banco. Rode `npm run web:env` para gerar o arquivo de ambiente e recarregue a página.',
    );
  }
  return {
    url,
    chavePublicavel: chave,
    /* Chave própria por ambiente: dev e produção dividindo localhost derrubariam a
       sessão um do outro. */
    chaveDeArmazenamento: amb.DEV === true ? 'fincast-dev-auth' : 'fincast-auth',
  };
}

/**
 * `true` quando o aplicativo publicado aponta para o banco de DESENVOLVIMENTO.
 *
 * Existe para a tela poder dizer isso em voz alta. Um endereço público que parece
 * produção e é dev acaba recebendo dado real de cliente — e o dado real não pode entrar
 * num banco onde as ferramentas de validação criam e apagam registros a cada rodada,
 * nem onde `cenario_versao` guarda para sempre o resíduo de teste.
 */
export function ehDemonstracao(): boolean {
  return amb.VITE_AMBIENTE === 'demonstracao';
}
